// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"92bae0f8","363":"eb29a625","378":"74eda3a5","694":"ecb0ca46","787":"f553b4e0"}[chunkId] + ".chunk.js";
};